import { render } from "./AppTitle.vue?vue&type=template&id=24d1da06&scoped=true&lang=pug"
import script from "./AppTitle.vue?vue&type=script&lang=js"
export * from "./AppTitle.vue?vue&type=script&lang=js"

import "./AppTitle.vue?vue&type=style&index=0&id=24d1da06&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d1da06"]])

export default __exports__